require('jquery-parallax.js/parallax.js')